import * as React from "react";
import { forwardRef } from "react";
const SvgAttachment = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", width: 256, height: 256, ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { style: {
  stroke: "none",
  strokeWidth: 0,
  strokeDasharray: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 10,
  fill: "none",
  fillRule: "nonzero",
  opacity: 1
} }, /* @__PURE__ */ React.createElement("path", { d: "M77.474 17.28 61.526 1.332A4.52 4.52 0 0 0 58.311 0H15.742a4.553 4.553 0 0 0-4.548 4.548v80.904A4.553 4.553 0 0 0 15.742 90h58.516a4.554 4.554 0 0 0 4.549-4.548V20.496a4.52 4.52 0 0 0-1.333-3.216M61.073 5.121l12.611 12.612H62.35a1.28 1.28 0 0 1-1.276-1.277zM74.258 87H15.742a1.55 1.55 0 0 1-1.548-1.548V4.548A1.55 1.55 0 0 1 15.742 3h42.332v13.456a4.28 4.28 0 0 0 4.276 4.277h13.457v64.719A1.55 1.55 0 0 1 74.258 87", style: {
  stroke: "none",
  strokeWidth: 1,
  strokeDasharray: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 10,
  fill: "#fff",
  fillRule: "nonzero",
  opacity: 1
}, transform: "translate(1.407 1.407)scale(2.81)" }), /* @__PURE__ */ React.createElement("path", { d: "M60.163 32.067a10.8 10.8 0 0 0-8.182-1.576 10.82 10.82 0 0 0-6.912 4.654 1.5 1.5 0 0 0 2.502 1.655 7.84 7.84 0 0 1 5.008-3.369 7.85 7.85 0 0 1 5.929 1.138c3.63 2.4 4.63 7.306 2.23 10.936L42.428 73.2a7.84 7.84 0 0 1-5.008 3.368 7.84 7.84 0 0 1-5.928-1.139 7.84 7.84 0 0 1-3.369-5.008 7.83 7.83 0 0 1 1.137-5.926l.002-.002 12.601-19.059a3.09 3.09 0 0 1 4.278-.872 3.06 3.06 0 0 1 1.316 1.958 3.06 3.06 0 0 1-.444 2.318L34.527 67.724a1.5 1.5 0 1 0 2.503 1.654l12.485-18.884a6.04 6.04 0 0 0 .882-4.572 6.04 6.04 0 0 0-2.602-3.861c-2.798-1.853-6.582-1.081-8.435 1.72L26.759 62.84l-.004.007c-3.307 5.008-1.925 11.774 3.083 15.085a10.83 10.83 0 0 0 5.99 1.804c3.537-.001 7.01-1.717 9.102-4.882L63.241 47.16c3.313-5.009 1.932-11.78-3.078-15.093", style: {
  stroke: "none",
  strokeWidth: 1,
  strokeDasharray: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 10,
  fill: "#fff",
  fillRule: "nonzero",
  opacity: 1
}, transform: "translate(1.407 1.407)scale(2.81)" })));
const ForwardRef = forwardRef(SvgAttachment);
export { ForwardRef as ReactComponent };
